// import Link from "next/link";
import {
  LayoutDashboard,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Mail,
  Phone,
} from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function Footer() {
  return (
    <footer className="bg-muted/30 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img src={logo} width={100} alt="logo" className="h-10 w-auto" />
              <span className="text-lg font-bold  bg-clip-text">
                finanza.lat
              </span>
            </Link>
            <p className="text-muted-foreground mb-6">
              Plataforma financiera para gestionar cuentas bancarias, ingresos,
              gastos y reportes automáticos. Ideal para freelancers, empresas y
              MYPEs en Perú.
            </p>
            {/* <div className="flex space-x-4">
              <Link to="#" className="text-muted-foreground hover:text-primary">
                <Facebook className="h-5 w-5" />
                <span className="sr-only">Facebook</span>
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary">
                <Twitter className="h-5 w-5" />
                <span className="sr-only">Twitter</span>
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary">
                <Instagram className="h-5 w-5" />
                <span className="sr-only">Instagram</span>
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary">
                <Linkedin className="h-5 w-5" />
                <span className="sr-only">LinkedIn</span>
              </Link>
            </div> */}
          </div>

          <div>
            {/* <h3 className="font-medium text-lg mb-4">Compañía</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Acerca de nosotros
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Carreras
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Prensa
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Socios
                </a>
              </li>
            </ul> */}
          </div>

          <div>
            <h3 className="font-medium text-lg mb-4">Producto</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#caracteristicas"
                  className="text-muted-foreground hover:text-primary"
                >
                  Características
                </a>
              </li>
              <li>
                <a
                  href="#precios"
                  className="text-muted-foreground hover:text-primary"
                >
                  Precios
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Seguridad
                </a>
              </li>
              {/* <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Documentación API
                </a>
              </li> */}
              {/* <li>
                <a
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Centro de ayuda
                </a>
              </li> */}
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-lg mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-muted-foreground">
                <Mail className="h-5 w-5" />
                <a href="mailto:b@finanza.lat" target="_blank">
                  <span>b@finanza.lat</span>
                </a>
              </li>
              <li className="flex items-center gap-2 text-muted-foreground">
                <Phone className="h-5 w-5" />
                <a href="https://wa.me/51975521788" target="_blank">
                  <span>+51 975521788</span>
                </a>
              </li>
              {/* <li className="pt-2">
                <Link
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Soporte
                </Link>
              </li>
              <li>
                <Link
                  href="#"
                  className="text-muted-foreground hover:text-primary"
                >
                  Ventas
                </Link>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="border-t border-muted pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} finanza.lat. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-6">
              <Link
                to="#"
                className="text-sm text-muted-foreground hover:text-primary"
              >
                Libro de reclamaciones
              </Link>
              <Link
                to="/terminos-y-condiciones"
                className="text-sm text-muted-foreground hover:text-primary"
              >
                Términos y condiciones
              </Link>
              <Link
                to="/politica-privacidad"
                className="text-sm text-muted-foreground hover:text-primary"
              >
                Política de privacidad
              </Link>
              {/* <Link
                href="#"
                className="text-sm text-muted-foreground hover:text-primary"
              >
                Cookies
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
